function CodeCopy() {
  const elements = document.querySelectorAll('[data-module="codecopy"]');
  const copyTips = document.querySelector('[data-module="copytips"]')

  elements.forEach(element => {
    element.addEventListener('click', () => {
      const target = element.querySelector('[data-code]');
      const code = target.dataset.code

      // // クリップボードにコピー
      navigator.clipboard.writeText(code)
        .then(() => {
          // コピー成功時の処理 (任意)
          // 例：element内に「コピーしました」と表示する
          copyTips.classList.add("show")
          setTimeout(() => {
            copyTips.classList.remove("show");
          }, 2000);
        })
        .catch(err => {
          console.error('コードのコピーに失敗しました: ', err);
          // コピー失敗時の処理 (任意)
        });
    });
  });
}

export {CodeCopy}
